module.exports = __webpack_public_path__ + "img/66.c3533d21.jpg";